import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { parse } from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from './useStewardshipFilter';
import getQueryUtils, { attributeKeys } from './queryUtils';
import { MISSING_FIELDS_$AGGREGATIONS } from './MISSING_FIELDS';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4
  } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('event.find', {
    where: {
      eager: {
        $aggregations: MISSING_FIELDS_$AGGREGATIONS,
        $where: {
          // $and: [...queryUtils.where],
          activityId: {
            $null: false
          },
          $or: stewardshipFilter
        },
        $having: {
          $and: [...queryUtils.having]
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData : true
  });
}
